import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormErrorsModule } from '@shared/components/form-elements/form-errors/form-errors.module';
import { InputCodeComponent } from '@shared/components/form-elements/input-code/input-code.component';
import { LocalLoaderComponent } from '@shared/components/loader/local-loader/local-loader.component';
import { ForgotPasswordService } from '@b2b/features/forgot-password-dialog/core/forgot-password.service';

@Component({
  selector: 'app-confirm-code',
  imports: [
    CommonModule,
    TranslateModule,
    InputCodeComponent,
    ReactiveFormsModule,
    FormErrorsModule,
    LocalLoaderComponent,
  ],
  templateUrl: './confirm-code.component.html',
  styleUrl: './confirm-code.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmCodeComponent {
  form = new FormGroup({
    code: new FormControl('', [Validators.required]),
  });

  isLoading$ = this.forgotPasswordService.isLoading$;
  message$ = this.forgotPasswordService.message$;
  error$ = this.forgotPasswordService.error$;

  constructor(private forgotPasswordService: ForgotPasswordService) {}

  resendCode() {
    this.forgotPasswordService.resendCode();
    this.form.reset();
  }

  submit() {
    if (this.form.valid) {
      this.forgotPasswordService.confirmCode(this.form.value.code!);
    }
  }
}
